/* eslint-disable prettier/prettier */
/* eslint-disable */
/* prettier-ignore-file */
// UserProfileCard.tsx
import { useEffect, useState } from 'react';
import styles from '../../../styles/components/pageComponents/manageUsers/UserProfileCard.module.css';
import { UserProfileCardProps, UserData } from '../../../types/manageUsers';
import save from '../../../assets/profile/save2.png';
import undo from '../../../assets/profile/Undo.png';
import Cancel from '../../../assets/profile/cancel2.png';
import edit from '../../../assets/profile/Edit.png';
import d from '../../../assets/profile/Delete.png';
import detail from '../../../assets/profile/Vector (3).png';
import growth from '../../../assets/profile/growth.png';
import cng from '../../../assets/profile/cng.png';
import Dropdown from '../../controlVariations/DropdownProgram';
import MultiSelectDropdown from '../../controlVariations/MultiSelectDropdownProgram';

export const UserProfileCard = ({
	mode,
	data,
	title,
	showEdit = true,
	showDelete = true,
	showClose = true,
	showUndo = true,
	showSave = true,
	onEdit,
	onDelete,
	onClose,
	onUndo,
	onSave,
	className,
	programOptions = [],
	roleOptions = [],
}: UserProfileCardProps) => {
	const [formData, setFormData] = useState<UserData>(data);
	const [removedPrograms, setRemovedPrograms] = useState<string[]>([]);
	// const [formData, setFormData] = useState<UserData>(data);

	// ✅ FIX: Sync state when new user data comes
	useEffect(() => {
		setFormData(data);
	}, [data]);
	const [initialPrograms, setInitialPrograms] = useState<string[]>([]);
	useEffect(() => {
		setFormData(data);

		const initial =
			data.enrolledProgram && data.enrolledProgram !== 'No Program'
				? data.enrolledProgram.split(',').map(p => p.trim())
				: [];

		setInitialPrograms(initial);
	}, [data]);

	
	const enrolledProgramsList =
		formData.enrolledProgram && formData.enrolledProgram !== 'No Program'
			? (formData.enrolledProgram
					.split(',')
					.map(p => p.trim())
					.map(label => {
						const match = programOptions.find(
							opt => opt.label === label
						);
						return match?.value;
					})
					.filter(Boolean) as string[])
			: [];

	const filteredProgramOptions = programOptions.filter(
		option => !enrolledProgramsList.includes(option.label)
	);

	// ✅ Convert options to string (labels only)
	const programLabels = programOptions.map(p => p.label);

	// ✅ Find selected label from stored value (id)
	const selectedProgramLabel =
		programOptions.find(p => p.value === formData.enrolledProgram)?.label ||
		'';

	const isEdit = mode === 'edit';
	const isGuest = !data.platformRole || data.platformRole === 'guest';

	const handleChange = (field: keyof UserData, value: string) => {
		setFormData(prev => ({
			...prev,
			[field]: value,
		}));
	};

	
	return (
		<div className={styles.modalOverlay} onClick={onClose}>
			<div
				className={styles.modalContent}
				onClick={e => e.stopPropagation()}
			>
				<div className={`${styles.card} ${className || ''}`}>
					{/* Header */}
					<div className={styles.header}>
						<h3>{title}</h3>

						<div className={styles.actions}>
							{/* Edit */}
							{mode === 'view' && showEdit && (
								<button
									className={styles.iconBtn}
									onClick={onEdit}
								>
									<img src={edit} alt="edit" />
								</button>
							)}

							{/* Undo */}
							{mode === 'edit' && showUndo && (
								<button
									className={styles.iconBtn}
									onClick={onUndo}
								>
									<img src={undo} alt="undo" />
								</button>
							)}

							{/* Save */}
							{mode === 'edit' && showSave && (
								<button
									className={styles.iconBtn}
									onClick={() =>
										//  onSave?.(formData)
										onSave?.(formData, removedPrograms)
									}
								>
									<img src={save} alt="save" />
								</button>
							)}

							{/* Delete */}
							{showDelete && (
								<button
									className={styles.iconBtn}
									onClick={() => onDelete?.()}
								>
									<img src={d} alt="delete" />
								</button>
							)}

							{/* Close */}
							{mode === 'view' && showClose && (
								<button
									className={styles.iconBtn}
									onClick={onClose}
								>
									<img src={Cancel} alt="close" />
								</button>
							)}
						</div>
					</div>

					{/* Body */}
					<div className={styles.body}>
						<div className={styles.profileRow}>
							{/* LEFT PROFILE */}
							<div className={styles.profileLeft}>
								<div className={styles.avatar}>
									{data.avatarUrl ? (
										<img src={data.avatarUrl} />
									) : (
										<div
											className={styles.placeholderAvatar}
										/>
									)}
								</div>

								<div className={styles.profileInfoWrapper}>
									<h4 className={styles.userName}>
										{data.name}
									</h4>

									<div className={styles.infoGrid}>
										<Info
											label="Email Id"
											value={data.email}
										/>
										<Info
											label="Phone Number"
											value={data.phone}
										/>
										<Info
											label="Time Zone"
											value={data.timezone}
										/>
										<Info
											label="Location"
											value={data.location}
										/>
										<Info
											label="Country Name"
											value={data.country}
										/>
									</div>
								</div>
							</div>

							{/* RIGHT BOXES */}
							<div className={styles.profileRight}>
								<div
									className={
										isEdit
											? styles.infoBoxEdit
											: styles.infoBox
									}
								>
									<label>Program</label>

									{isEdit && !isGuest ? (
										<MultiSelectDropdown
											placeholder="Select Program"
											options={programOptions} // already {label, value}
											selectedValues={
												enrolledProgramsList
											}
											onChange={values => {
												const selectedLabels = values
													.map(val => {
														const match =
															programOptions.find(
																p =>
																	p.value ===
																	val
															);
														return match?.label;
													})
													.filter(
														Boolean
													) as string[];

												// ✅ Compare ONLY with initial programs (API data)
												const removed =
													initialPrograms.filter(
														p =>
															!selectedLabels.includes(
																p
															)
													);

												// 🔥 ONLY trigger delete if removing EXISTING enrollment
												if (removed.length > 0) {
													onDelete?.(removed);
													return;
												}

												// ✅ Normal selection (no delete)
												handleChange(
													'enrolledProgram',
													selectedLabels.join(', ')
												);
											}}
											width="100%"
											height="48px"
										/>
									) : (
										// <div className={styles.roleBadge}>{data.enrolledProgram}</div>
										<div
											className={
												styles.roleBadgeContainer
											}
										>
											{data.enrolledProgram &&
											data.enrolledProgram !==
												'No Program' ? (
												data.enrolledProgram
													.split(',')
													.map((program, index) => (
														<span
															key={index}
															className={
																styles.roleBadge
															}
														>
															{program.trim()}
														</span>
													))
											) : (
												<span
													className={styles.roleBadge}
												>
													No Program
												</span>
											)}
										</div>
									)}
								</div>

								<div
									className={
										isEdit
											? styles.infoBoxEdit
											: styles.infoBox
									}
								>
									<label>IOCM E2I Platform Role</label>

									{isEdit && isGuest ? (
										<Dropdown
											placeholder="Select Role"
											options={
												roleOptions?.map(
													r => r.label
												) || []
											}
											selected={
												roleOptions?.find(
													r =>
														r.value ===
														formData.platformRole
												)?.label || ''
											}
											onSelect={label => {
												const selectedRole =
													roleOptions?.find(
														r => r.label === label
													);
												handleChange(
													'platformRole',
													selectedRole?.value || ''
												);
											}}
											width="100%"
											height="48px"
										/>
									) : (
										<div className={styles.roleBadgerole}>
											{' '}
											{data.platformRole}{' '}
										</div>
									)}
								</div>
							</div>
						</div>

						{/* Sections */}
						<div className={styles.sections}>
							<Section title="Professional Details" icon={detail}>
								<Info
									label="Organization Name"
									value={data.organization}
								/>

								<Info
									label="Current Professional Role"
									value={data.professionalRole}
								/>

								<div>
									<label className={styles.area}>
										Areas of Interest
									</label>

									<div className={styles.tags}>
										{data.areasOfInterest?.map(item => (
											<span key={item}>{item}</span>
										))}
									</div>
								</div>
							</Section>

							<Section title="Coaching Experience" icon={cng}>
								<label className={styles.area}>
									What primarily brings you to IOCM at this
									point?
								</label>
								<div className={styles.tags}>
									{data.coachingExperience?.map(item => (
										<span key={item}>{item}</span>
									))}
								</div>
							</Section>

							<Section title="Growth with IOCM" icon={growth}>
								<label className={styles.area}>
									What can IOCM do which might be useful for
									you now?
								</label>
								<div className={styles.tags}>
									{data.growthWithIOCM?.map(item => (
										<span key={item}>{item}</span>
									))}
								</div>
							</Section>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const Section = ({
	title,
	icon,
	children,
}: {
	title: string;
	icon?: string;
	children: React.ReactNode;
}) => (
	<div className={styles.sectionCard}>
		<div className={styles.sectionHeader}>
			<div className={styles.sectioniconCont}>
				{icon && <img src={icon} className={styles.sectionIcon} />}
			</div>

			<h5>{title}</h5>
		</div>

		{children}
	</div>
);

const Info = ({ label, value }: { label: string; value?: string }) => (
	<div className={styles.infoItem}>
		<label>{label}</label>
		<p>{value || '-'}</p>
	</div>
);
